export default "__VITE_ASSET__Crx2xSOS__"